<template>
  <!-- 登录页 -->
  <div class="rbd-root">
    <div v-if="authLoginloading" class="rbd-screen-mask">
      <a-spin
        class="ant-mask-spin"
        :spinning="true"
        tip="授权登录中"
        size="large"
      >
      </a-spin>
    </div>
    <div v-else class="rbd-login" :style="bgStyle">
      <main class="rbd-main flex-am">
        <!-- <div class="rbd-main-logo pos-a flex-middle font-32">
          <img
            class="m-r-12"
            :src="require('@/assets/images/common/login/logo.png')"
            alt="XXX指挥学院"
          />
          <span>武警指挥学院</span>
        </div> -->
        <!-- <img
          class="rbd-main-tip pos-a"
          :src="require('@/assets/images/common/login/login-tip.png')"
          alt="login-tip"
        />
        <img
          class="rbd-main-fly pos-a"
          :src="require('@/assets/images/common/login/login-fly.png')"
          alt="login-fly"
        /> -->
        <div class="rbd-main-form flex-middle flex-center flex-col">
          <a-form-model
            ref="loginForm"
            :model="form"
            :rules="formRules"
            class="rbd-form-login pos-r"
            @submit="onSubmit"
          >
            <!-- <div class="rbd-form-login-box flex-center pos-a">
              <img
                :src="require('@/assets/images/common/login/logo.png')"
                alt="武警指挥学院"
              />
            </div> -->
            <a-form-model-item>
              <a-radio-group
                v-model="form.is_admin"
                :disabled="isLoading"
                @change="onChangeRole"
              >
                <a-radio-button class="rbd-switch-radio" :value="0">
                  用户登录
                </a-radio-button>
                <a-radio-button class="rbd-switch-radio" :value="1">
                  管理员登录
                </a-radio-button>
                <span
                  class="rbd-active-line"
                  :style="`transform: translate3d(${
                    form.is_admin ? '100%' : '0%'
                  },0,0);`"
                ></span>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="username">
              <a-input
                v-model="form.username"
                size="large"
                placeholder="用户名"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input
                v-model="form.password"
                size="large"
                type="password"
                placeholder="密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                type="default"
                size="large"
                html-type="submit"
                block
                class="rbd-btn-login"
                :loading="isLoading"
              >
                登录
              </a-button>
            </a-form-model-item>
            <div class="rbd-form-explain">
              <p>
                为了更好的体验效果，请在1920*1080分辨率下使用，推荐使用以下浏览器：
              </p>
              <p class="flex-row flex-middle">
                <i class="rbd-icon-gg"></i><span>谷歌</span>
                <i class="rbd-icon-hh"></i><span>火狐</span>
                <i class="rbd-icon-sll"></i><span>360（极速模式）</span>
              </p>
            </div>
          </a-form-model>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  apiGetPublicKey,
  apiGetCasConfig,
  userLogin,
  apiAdminLogin,
  apiGetConfig,
  userTokenLogin,
  apiChoicePlatform,
  apiGetCommonConfig,
  apiGetLoginConfig,
} from "../../services/commonApi";
import { __FUNC__ } from "../../utils/func";
export default {
  data() {
    return {
      isLoading: false,
      cas_enable: false,
      authLoginloading: false,
      picture: require("@/assets/images/common/login/login-bg.png"),
      bgStyle: {
        background: `url(${require("@/assets/images/common/login/login-bg.png")}) center center / cover no-repeat`,
      },
      form: {
        is_admin: 0, //0,1
        username: "",
        password: "",
      },
      formRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        public_key: "",
      },
    };
  },
  async created() {
    const that = this;
    let urlBackParam = this.$route.query;
    that.mtt_removeUser();
    // 获取登录页背景图;
    this.getLoginConfig();
    apiGetCasConfig().then((res) => {
      that.cas_enable = res.result.cas_enable;
      that.mtt_casInfo(res.result);
      if (res.result.cas_enable === true) {
        if (!urlBackParam.ticket && !urlBackParam.code) {
          window.location.href = "/user/login";
        }
      } else {
        this.authLoginloading = false;
      }
    });

    const public_key = window.localStorage.getItem("public_key");
    if (!public_key) {
      apiGetPublicKey().then((res) => {
        that.public_key = res.key;
        window.localStorage.setItem("public_key", res.key);
      });
    } else {
      that.public_key = public_key;
    }

    if (urlBackParam) {
      if (urlBackParam.ticket || urlBackParam.code) {
        that.authLoginloading = true;
        userTokenLogin(urlBackParam).then((res_user) => {
          that.loginCallBack(res_user);
          // let { user_info } = res_user;
          // if (user_info.username.length == 10) {
          //   that.JumpOutside();
          // }
        });
      }
    }
  },
  methods: {
    ...mapMutations([
      "mtt_removeUser",
      "mtt_userInfo",
      "mtt_authMenu",
      "mtt_setToken",
      "mtt_casInfo",
      "mtt_setPlatformInfo",
      "mtt_logoConfig",
    ]),
    onChangeRole() {
      this.$refs.loginForm.resetFields();
    },
    onSubmit(e) {
      e.preventDefault();
      const that = this;
      that.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return;
        }
        that.isLoading = true;
        let that_form = that.form;
        let is_admin = that_form.is_admin;
        let queryPath = that.$route.query && that.$route.query.redirect;
        let _pathName = that_form["is_admin"] ? "/cms" : "/web";
        let rsaPassword = __FUNC__.rsaEncryptedData({
          public_key: that.public_key,
          password: that_form.password,
        });
        let promiseLogin = that.cas_enable
          ? apiAdminLogin({ ...that_form, password: rsaPassword })
          : userLogin({ ...that_form, password: rsaPassword });
        promiseLogin
          .then((res) => {
            that.loginCallBack(res);
            // let { user_info } = res;
            // if (user_info.username.length == 10) {
            //   that.JumpOutside();
            // }
          })
          .catch((err) => {
            setTimeout(() => {
              that.isLoading = false;
            }, 200);
          });
      });
    },
    JumpOutside() {
      const newWindow = window.open(
        "http://218.63.77.158:8889/workflow/request/ViewRequestForwardSPA.jsp?requestid=99999999999",
        "externalLink",
        "width=1,height=1,top=0, left=0, toolbar=no, menubar=no,scrollbars=no, resizable=no, location=no, status=no"
      );
      newWindow.moveTo(-1000, -500);
      // 设置定时器，在指定时间后关闭新窗口
      setTimeout(() => {
        if (newWindow && !newWindow.closed) {
          newWindow.close();
        }
      }, 3000);
    },
    loginCallBack(res) {
      const that = this;
      let that_form = that.form;
      let is_admin = that_form.is_admin;
      let queryPath = that.$route.query && that.$route.query.redirect;
      let _pathName = that_form["is_admin"] ? "/cms" : "/web";
      // 平台个数
      const platformCount = res.menus.plant_front.length;
      apiGetCommonConfig()
        .then(({ data }) => {
          that.storageLogoConfig(
            data,
            platformCount > 1
              ? { platform_name: "一体化服务平台" }
              : res.menus.plant_front[0]
          );
        })
        .finally(() => {
          // const platformCount = 1;
          if (platformCount > 1 && !is_admin) {
            //存储token
            that.mtt_setToken(res.Authorization);
            //存储用户信息
            that.mtt_userInfo({ ...res.user_info, is_admin });
            window.sessionStorage.setItem(
              "PLANT_FRONT",
              JSON.stringify(res.menus.plant_front)
            );
            that.$router.push({ name: "platformSelection" });
          } else {
            //存储用户菜单
            let authRoutes = [];
            const loopMenu = (data) => {
              data.forEach((menu) => {
                if (menu.relationRoutes?.length) {
                  authRoutes.push(...menu.relationRoutes);
                }
                if (menu.children?.length) {
                  loopMenu(menu.children);
                }
              });
            };

            if (is_admin) {
              loopMenu(res.menus.cms);
            } else {
              authRoutes = __FUNC__.getAuthRoutes(res.menus.plant_front[0]);
              that.mtt_setPlatformInfo(res.menus.plant_front[0]);
            }
            if (!authRoutes.length) {
              that.$message.destroy();
              that.$message.error("未读取到当前用户权限菜单，请稍后重试！");
              setTimeout(() => {
                that.isLoading = false;
              }, 500);
              return;
            }
            //存储token
            that.mtt_setToken(res.Authorization);
            //存储用户信息
            that.mtt_userInfo({ ...res.user_info, is_admin });
            that.mtt_authMenu(authRoutes);
            if (res.error === "warning" || res.error === "error") {
              that.$message[res.error](res.message);
            }
            //记忆跳转
            setTimeout(() => {
              that.$message.destroy();
              if (queryPath) {
                that.$router.push({ path: queryPath });
              } else {
                if (_pathName === "/web") {
                  apiChoicePlatform({
                    platform_id: res.menus.plant_front[0].platform_id,
                  }).then(() => {
                    let { index_url, web } = res.menus.plant_front[0];
                    if (index_url) {
                      that.$router.push({ name: index_url });
                    } else {
                      that.$router.push({ name: authRoutes[0] });
                    }
                  });
                } else {
                  that.$router.push({ path: _pathName });
                }
              }
            }, 1000);
          }
        });
    },
    getUrlParms(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 保存logo配置
    storageLogoConfig({ icon, logo, backend }, platformInfo) {
      const logoConfig = {
        icon: icon ?? null,
        logo: logo ?? null,
        backend: backend ?? { title: "", font: "微软雅黑" },
        front: { title: platformInfo?.platform_name ?? "" },
      };

      this.mtt_logoConfig(logoConfig);
      document.querySelector("#browserIcon").href = logoConfig.icon;
      document.title = this.form.is_admin
        ? logoConfig.backend.title
        : logoConfig.front.title;
    },
    //获取logo配置
    getConfig() {
      apiGetConfig().then((res_config) => {
        this.mtt_logoConfig(res_config.data);
        window.localStorage.setItem(
          "__LOGO__CONFIG",
          JSON.stringify(res_config.data)
        );
        document.querySelector("#browserIcon").href = res_config.data.icon;
      });
    },
    // 获取登录页背景图
    getLoginConfig() {
      apiGetLoginConfig()
        .then(({ data }) => {
          if (Object.values(data).length) {
            this.bgStyle.background = `url(${data.picture}) center center / cover no-repeat`;
          } else {
            this.bgStyle.background = `url(${require("@/assets/images/common/login/login-bg.png")}) center center / cover no-repeat`;
          }
        })
        .catch(() => {
          this.bgStyle.background = `url(${require("@/assets/images/common/login/login-bg.png")}) center center / cover no-repeat`;
        });
    },
  },
};
</script>

<style scoped lang="scss" src="./index.scss"></style>
